/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */

export const MODEL_HEADER = {
    cafeteria: null,
    date: new Date()
}

export const TABS_KITCHEN = {
    ORDERS: {
        INDEX: 0,
        TRANS: "orders",
    },
    HISTORY: {
        INDEX: 1,
        TRANS: "history",
    },
};

export const today = new Date();
today.setHours(0, 0, 0, 0);

export const yesterday = new Date(today);
yesterday.setDate(today.getDate() - 1);
